import {useMutation} from "@tanstack/react-query";

import {editClientContactMutationOptions} from "./edit-client-contact.mutation-options";

export function useEditClientContact(clientId: string, contactId: number) {
  return useMutation(editClientContactMutationOptions(clientId, contactId));
}
